import React from 'react';
import {Col, Glyphicon, Panel, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import classnames from 'classnames';
import ArrowButton from '../common/button-arrow';
import {MODULE_LEVEL} from '../../data/modules';
import Module from '../common/module';
import t from '../../data/translations';

const Store = ({
  store, open, row, onManageClicked
}) => {
  const details = `/store-details/${store.id}`;
  const {level} = store.attributes;
  const panelFooter = (
    <div>
      <p>
        No. staff
        <span className="staff-number">
          {store.attributes['num-of-staff'] || 0}
        </span>
      </p>
      <Link to={details}>
        <ArrowButton
          className="btn-block"
          color="red"
          submit={false}
        >
          Details
        </ArrowButton>
      </Link>
      <p>
        { t('staffRewards.balance') }
      </p>
      <Row>
        <Col md={12}>
          <p className="staff-rewards-balance">
            {store.attributes['staff-rewards-balance']}
          </p>
        </Col>
        <Col md={6}>
          <Module name={MODULE_LEVEL}>
            <p>
              {level && (
                <span>
Store level:
                  {level}
                </span>
              )}
            </p>
          </Module>
        </Col>
        <Col md={6}>
          <ArrowButton
            arrow={false}
            className="manage-staff-rewards-button"
            color="red"
            onClick={() => onManageClicked(store.id, row)}
            submit={false}
          >
            <Glyphicon glyph="edit"/>
            Manage
          </ArrowButton>
        </Col>
      </Row>
    </div>
  );

  return (
    <Col lg={3} md={6}>
      <Panel className={classnames('store-item', {open})} footer={panelFooter}>
        <div className="store-name">
          {store.attributes.name}
        </div>
        <div className="customer-number">
          {store.attributes['customer-number']}
        </div>
      </Panel>
    </Col>
  );
};

export default Store;



// WEBPACK FOOTER //
// ./src/components/staff-rewards/store.jsx